export default __webpack_public_path__ + "static/media/microphone.f1a8b4ee.svg";